<div id="dictionary-input-border">
    <div id="input-border">
        <input 
            (click)="onClick()"
            (blur)="onBlur()"
            [ngStyle]="id"
            placeholder="Search for a word..." 
            [(ngModel)]="input" 
            (keyup.enter)="onEnter()" 
        />    
    </div>
    <app-word-data 
        [definition]="definition" 
        [examples]="examples" 
        [themes]="themes" 
        [association]="association" 
        [related_terms]="related_terms" 
        [input]="input">
</app-word-data>    
</div>